import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SaasButton from '../saas/Button';

/**
 * نوار تبدیل ثابت — فقط موبایل، بعد از اسکرول از هیرو
 */
const LandingMobileCta = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 420);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 md:hidden">
      <div className="pointer-events-auto mx-auto max-w-page px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2">
        <div className="flex gap-2 rounded-2xl border border-hairline/45 bg-card-surface/92 p-2 shadow-[0_-8px_32px_-8px_rgba(15,31,61,0.18)] backdrop-blur-md">
          <SaasButton
            to="/register"
            variant="gradient"
            className="min-h-[48px] flex-1 justify-center px-3 text-sm font-semibold"
          >
            {t('hero.ctaBusiness')}
          </SaasButton>
          <SaasButton
            to="/login"
            variant="outline"
            className="min-h-[48px] flex-1 justify-center border-hairline/70 px-3 text-sm font-medium"
          >
            {t('hero.ctaLogin')}
          </SaasButton>
        </div>
      </div>
    </div>
  );
};

export default LandingMobileCta;
